import axios from "axios";
import { AppConfig } from "../Config";
const VERSION = "v1";

export const GET_START_SURVEY = (payload) =>
  axios.get(`${AppConfig.api.surveyApiUrl}/${VERSION}/start-survey/${payload ? payload : ''}`);

export const GET_CULTURE_QUESTIONS = (payload) =>
  axios.get(`${AppConfig.api.surveyApiUrl}/${VERSION}/culture-questions/${payload ? payload : ''}`);

export const GET_MOOD_QUESTIONS = (payload) =>
  axios.get(`${AppConfig.api.surveyApiUrl}/${VERSION}/mood-questions/${payload ? payload : ''}`);

export const GET_LEADERSHIP_QUESTIONS = (payload) =>
  axios.get(`${AppConfig.api.surveyApiUrl}/${VERSION}/leadership-questions/${payload ? payload : ''}`);

export const GET_PERSONALITY_QUESTIONS = (payload) =>
  axios.get(`${AppConfig.api.surveyApiUrl}/${VERSION}/personality-questions/${payload ? payload : ''}`);

export const GET_PREVIOUS_RESPONSE = (payload) =>
  axios.get(`${AppConfig.api.surveyApiUrl}/${VERSION}/previous-response/${payload ? payload : ''}`);


export const POST_ANSWER = (answers) =>
  axios.post(`${AppConfig.api.surveyApiUrl}/${VERSION}/survey-response/`, answers);

export const START_PERSONALITY_ANSWER = (payload) => {
  return axios.post(
    `${AppConfig.api.surveyApiUrl}/${VERSION}/personality-updates/`,
    payload);
}
export const UPDATE_PERSONALITY_ANSWER = (token, payload) => {
  return axios.patch(
    `${AppConfig.api.surveyApiUrl}/${VERSION}/personality-updates/${token}/`,
    payload);
}

export const GET_PERSONALITY_ANSWER = (payload) =>
  axios.get(`${AppConfig.api.surveyApiUrl}/${VERSION}/personality-updates/${payload ? `${payload}` : ''}`);

export const GET_CULTURE = () => {
  return;
};

export const GET_MOODS = () => {
  return;
};

export const GET_BRIEF_SURVEY = (payload) =>
  axios.get(`${AppConfig.api.surveyApiUrl}/${VERSION}/brief-token/${payload ? payload : ''}`);

export const UPDATE_BRIEF_RESPONSE = (payload) => {
  return axios.patch(`${AppConfig.api.surveyApiUrl}/${VERSION}/brief-token/${payload?.id}/${payload?.query ? payload?.query : ''}`, payload);
}

export const POST_BRIEF_RESPONSE = (answers) =>
  axios.post(`${AppConfig.api.surveyApiUrl}/${VERSION}/brief-response/`, answers);

export const GET_BRIEF_MODULAR_QUESTIONS = (payload) =>
  axios.get(`${AppConfig.api.surveyApiUrl}/${VERSION}/brief-component-question/${payload ? payload : ''}`);

export const GET_CHAT_GPT_SUMMARY = (payload) => {
  return axios.post(
    `${AppConfig.api.surveyApiUrl}/${VERSION}/chat-gpt-summary/`,
    payload);
}

export const GET_CHAT_GPT_SUMMARY_MULTI = (payload) => {
  return axios.post(
    `${AppConfig.api.surveyApiUrl}/${VERSION}/chat-gpt-summary-multi/`,
    payload);
}

export const POST_MARKETING_ROI = (marketingRoi) =>
  axios.post(`${AppConfig.api.surveyApiUrl}/${VERSION}/marketing-response/`, marketingRoi);
